import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  CardMedia,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";

import MainContainer from "../../layout/MainContainer";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const EditServiceProvider = () => {
  const navigate = useNavigate();

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  // dropdown states
  const [status, setStatus] = useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  const [serviceType, setServiceType] = useState("default");
  const handleServiceTypeChange = (event: SelectChangeEvent) => {
    setServiceType(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Edit Service Provider</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-service-providers")}>
            Manage Service Providers
          </button>{" "}
          - Edit
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            {/* Upload Image */}
            <div className="control_group">
              <label htmlFor="icon-button-file">Upload Image</label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = event.target.files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        setAlertType(0);
                        setShowAlert(true);
                        setAlertMessage("This field only accepts images.");
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img src="/static/images/placeholder.png" alt="icon" />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            {/* Full Name */}
            <div className="control_group w_33">
              <label htmlFor="fullName">Full Name</label>
              <TextField id="fullName" placeholder="Enter Full Name" hiddenLabel fullWidth />
            </div>

            {/* Email */}
            <div className="control_group w_33">
              <label htmlFor="email">Email</label>
              <TextField
                id="email"
                type="email"
                placeholder="Enter Email"
                hiddenLabel
                fullWidth
              />
            </div>

            {/* Phone */}
            <div className="control_group w_33">
              <label htmlFor="phone">Phone</label>
              <TextField
                id="phone"
                type="tel"
                placeholder="Enter Phone Number"
                hiddenLabel
                fullWidth
              />
            </div>

            {/* Service Type */}
            <div className="control_group w_33">
              <label htmlFor="serviceType">Service Type</label>
              <Select
                id="serviceType"
                fullWidth
                value={serviceType}
                onChange={handleServiceTypeChange}
              >
                <MenuItem disabled value="default">
                  Select Service Type
                </MenuItem>
                <MenuItem value="Plumber">Haircut & spa</MenuItem>
                <MenuItem value="Electrician">Cutting</MenuItem>
                <MenuItem value="Tutor">Facial Treatment</MenuItem>
                <MenuItem value="BeardStyling">Beard Styling</MenuItem>
                <MenuItem value="BeardTrimFacial">Beard Trim + Facial</MenuItem>
                <MenuItem value="FacialHeadMassage">Facial + Head Massage</MenuItem>
                <MenuItem value="HairSpaPedicure">Hair Spa + Pedicure</MenuItem>
              </Select>
            </div>

            {/* Status */}
            <div className="control_group w_33">
              <label htmlFor="status">Status</label>
              <Select id="status" fullWidth value={status} onChange={handleStatusChange}>
                <MenuItem disabled value="default">
                  Select Status
                </MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
              </Select>
            </div>

            {/* Joining Date */}
            <div className="control_group w_33">
              <label htmlFor="joiningDate">Joining Date</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slotProps={{
                    textField: {
                      id: "joiningDate",
                      placeholder: "Select Date",
                      fullWidth: true,
                      hiddenLabel: true,
                    },
                  }}
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/date_icon.svg" alt="icon" />
                    ),
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>
          </div>


          {/* Submit */}
          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditServiceProvider;
